// extracted by mini-css-extract-plugin
module.exports =  {"category-list":"YEE03b6","categoryList":"YEE03b6"};